import { PhaseSpan } from './types';

type DateRangeIso = { start: string; end: string };

type RawPhase = {
  id: string;
  name: string;
  color: string;
  startDate: string;
  endDate: string;
};

export function clampPhasesToRange(
  phases: readonly RawPhase[],
  range: DateRangeIso,
): PhaseSpan[] {
  return phases
    .filter((p) => p.startDate <= range.end && p.endDate >= range.start)
    .map((p) => ({
      id: p.id,
      name: p.name,
      color: p.color,
      startDate: p.startDate < range.start ? range.start : p.startDate,
      endDate: p.endDate > range.end ? range.end : p.endDate,
    }));
}
